export const isCountryUS = (countryId: number): boolean => countryId === 1;

export const isCountryCA = (countryId: number): boolean => countryId === 3;

export const isNorthAmericaCountry = (countryId: number): boolean => (
  isCountryUS(countryId) || isCountryCA(countryId)
);

export const isAustralia = (countryId: number): boolean => countryId === 4;

export const isSouthAfrica = (countryId: number): boolean => countryId === 88;

export const isTurkey = (countryId: number): boolean => countryId === 96;

const COUNTRY_ID_MALAYSIA = 59;
export const isMalaysia = (countryId: number): boolean => countryId === COUNTRY_ID_MALAYSIA;

export const COUNTRY_ID_HONGKONG = 281;
export const isHongKong = (countryId: number): boolean => countryId === COUNTRY_ID_HONGKONG;

export const COUNTRY_ID_JAPAN = 46;
export const isJapan = (countryId: number): boolean => countryId === COUNTRY_ID_JAPAN;

export const isMacau = (countryId: number): boolean => countryId === 250;

export const isMexico = (countryId: number): boolean => countryId === 61;

export const isColombia = (countryId: number): boolean => countryId === 128;

export const isChile = (countryId: number): boolean => countryId === 127;